import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/LiveEvents.css';

const LiveEvents = () => {
  return (
    <>
      <Helmet>
        <title>Live Events - Conferences & Business Forums | Redbox Global</title>
        <meta name="description" content="Attend Redbox Global live events, conferences, and business forums. Connect with industry leaders, attend keynotes, and network at premier business gatherings worldwide." />
        <meta name="keywords" content="business conferences, live events, business forums, networking events, industry conferences, business summits, keynote speakers, corporate events" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/live-events" />
        <meta property="og:title" content="Live Events - Conferences & Business Forums | Redbox Global" />
        <meta property="og:description" content="Attend premier business conferences and forums. Connect with industry leaders at Redbox Global live events." />
        <meta property="og:image" content="https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=1200&h=630&fit=crop" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://redboxglobal.com/live-events" />
        <meta name="twitter:title" content="Live Events - Conferences & Business Forums | Redbox Global" />
        <meta name="twitter:description" content="Attend premier business conferences and forums. Connect with industry leaders at Redbox Global live events." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=1200&h=630&fit=crop" />
        
        {/* Additional SEO */}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/live-events" />
      </Helmet>
      
      <div className="page-container">
        <div className="page-header">
          <h1>Live Events</h1>
          <p className="page-subtitle">Premier conferences and forums bringing together global business leaders</p>
        </div>
        
        <div className="page-content">
          <a href="/article/global-business-summit-2026" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <div className="featured-article">
              <div className="featured-image">
                <img src="https://images.unsplash.com/photo-1540575467063-178a50c2df87?w=1200&h=600&fit=crop" alt="Business conference" />
              </div>
              <div className="featured-content">
               
                <h2>Global Business Summit 2026</h2>
                <p>Join 5,000+ executives, investors, and innovators at our flagship annual event. Three days of keynote speeches, panel discussions, and networking opportunities with world-class business leaders. Featured speakers include Fortune 500 CEOs, policy makers, and renowned economists.</p>
                <span className="article-meta">September 15-17, 2026 • New York City</span>
              </div>
            </div>
          </a>

          <div className="content-grid">
            <a href="/article/future-of-finance-forum" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1591115765373-5207764f72e7?w=600&h=400&fit=crop" alt="Finance forum" />
                </div>
                <div className="article-content">
                  
                  <h2>Future of Finance Forum</h2>
                  <p>Exploring fintech, digital currencies, and the evolution of global banking systems.</p>
                  <span className="article-meta">May 20-21, 2026 • London</span>
                </div>
              </article>
            </a>

            <a href="/article/tech-innovation-summit" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1505373877841-8d25f7d46678?w=600&h=400&fit=crop" alt="Tech summit" />
                </div>
                <div className="article-content">
                  
                  <h2>Tech Innovation Summit</h2>
                  <p>AI, quantum computing, and breakthrough technologies shaping the next decade.</p>
                  <span className="article-meta">July 10-11, 2026 • San Francisco</span>
                </div>
              </article>
            </a>

            <a href="/article/sustainable-business-conference" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
              <article className="article-card">
                <div className="article-image">
                  <img src="https://images.unsplash.com/photo-1559223607-9dbbc0d30eb7?w=600&h=400&fit=crop" alt="Sustainability conference" />
                </div>
                <div className="article-content">
                 
                  <h2>Sustainable Business Conference</h2>
                  <p>Leading the transition to net-zero economies and sustainable corporate practices.</p>
                  <span className="article-meta">October 5-6, 2026 • Singapore</span>
                </div>
              </article>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default LiveEvents;
